import type { App } from 'vue';
import oidc, { guard } from '@libs/oidc';

import { router } from '@/plugins/router';

const install = (app: App) => {
  router.beforeEach(guard);
  app.use(oidc);
};

export { install };
